/* eslint-disable no-console */
import { isNil, isNonEmptyObject, isNonEmptyString } from '../checks'

type LogType = 'error' | 'warn' | 'info' | 'debug' | 'log'

interface Logger {
  (props: { error?: Error; message?: string; data?: object }): void
}

interface LoggerFactoryInterface {
  (logType: LogType): Logger
}

const LoggerFactory: LoggerFactoryInterface = (logType) => (props) => {
  const { error, message = '', data = {} } = props || {}

  const logArgs: unknown[] = []

  if (isNonEmptyString(message)) {
    logArgs.push('Message:', message)
  }

  if (!isNil(error)) {
    logArgs.push('Error:', error)
  }

  if (isNonEmptyObject(data)) {
    logArgs.push('Data:', JSON.stringify(data, null, 2))
  }

  if (logArgs.length === 0) {
    console.warn('Error:', new Error(`No params provided to logger.${logType}`))
    return
  }

  console[logType](...logArgs)
}

export default {
  error: LoggerFactory('error'),
  warn: LoggerFactory('warn'),
  info: LoggerFactory('info'),
  debug: LoggerFactory('debug'),
  log: LoggerFactory('log')
}
